module.exports = new __parcel__URL__("inquiry_ja.ed9aef2f.webp").toString();